module.exports = __webpack_public_path__ + "img/avatar2_p.d274bae1.svg";